module.exports = __webpack_public_path__ + "img/zhxy_image_16.75fd55b7.png";